/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type userStorageActions = {
    readonly isVerifiedTrade: boolean | null;
    readonly isVip: boolean | null;
    readonly " $refType": "userStorageActions";
};
export type userStorageActions$data = userStorageActions;
export type userStorageActions$key = {
    readonly " $data"?: userStorageActions$data;
    readonly " $fragmentRefs": FragmentRefs<"userStorageActions">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userStorageActions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVip",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'b731139716173823ea17c3fbc263b857';
export default node;
